import { SPOTLIGHT_TARGETS } from "../spotlightTargets";
import { SPOTLIGHT_EVENTS } from "../spotlightEventNames";
import { COMPLETE_CHAPTER } from "../tutorialEngine";

const GRADUATE_ACCOUNT_VALUE = "G";
const FRIENDS_FAMILY_ACCOUNT_VALUE = "F";

const isGraduate = (userData) => userData?.accountType === "Graduate";

const basicProfileChapter = {
	id: "basic-profile",
	title: "Basic Profile",
	route: "Profile",
	next: () => "graduate-profile",
	steps: [
		{
			id: "profile-intro",
			target: SPOTLIGHT_TARGETS.PROFILE_PAGE,
			placement: "center",
			title: "Welcome to your profile",
			body: "This is home base for your account: your name, email, password, and later your graduation details. Let's take a quick look around.",
		},
		{
			id: "first-name",
			target: SPOTLIGHT_TARGETS.PROFILE_FIRST_NAME,
			title: "First name",
			body: "This is how you'll appear to friends and family on MyTassel. If it already looks right, there's nothing to change.",
		},
		{
			id: "last-name",
			target: SPOTLIGHT_TARGETS.PROFILE_LAST_NAME,
			title: "Last name",
			body: "Same here. Your full name shows on your announcement page and registry.",
		},
		{
			id: "email",
			target: SPOTLIGHT_TARGETS.PROFILE_EMAIL,
			title: "Email",
			body: "Your email is how you log in and where we send important updates. If you ever change it, we'll ask you to verify the new address.",
		},
		{
			id: "password",
			target: SPOTLIGHT_TARGETS.PROFILE_PASSWORD,
			title: "Password",
			body: "Type a new password here any time, or leave it blank to keep your current one. Forgot it? Use Reset Password Via Email.",
		},
		{
			id: "account-type",
			target: SPOTLIGHT_TARGETS.PROFILE_ACCOUNT_TYPE,
			title: "Account type",
			body: "MyTassel has two kinds of accounts.",
			bullets: [
				{ label: "Friends & Family", text: "for supporting graduates: visit their pages, RSVP, and cheer them on." },
				{ label: "Graduate", text: "for creating your graduation announcement and events, plus your Registry and Grad Fund." },
			],
			actionLabel: ({ userData }) => (isGraduate(userData) ? "Next" : "Let's do it"),
			skipTo: ({ userData }) => (isGraduate(userData) ? "save" : undefined),
		},
		{
			id: "account-type-select",
			target: SPOTLIGHT_TARGETS.PROFILE_ACCOUNT_TYPE,
			silent: true,
			interactive: true,
			instruction: "Select your account type",
			waitFor: [
				{ event: SPOTLIGHT_EVENTS.PROFILE_ACCOUNT_TYPE_SELECTED, when: ({ value }) => value === GRADUATE_ACCOUNT_VALUE },
				// Friends & Family accounts don't run the Graduate onboarding flow.
				{ event: SPOTLIGHT_EVENTS.PROFILE_ACCOUNT_TYPE_SELECTED, when: ({ value }) => value === FRIENDS_FAMILY_ACCOUNT_VALUE, goto: "@complete" },
			],
		},
		{
			id: "account-type-confirm-modal",
			target: SPOTLIGHT_TARGETS.PROFILE_ACCOUNT_TYPE_CONFIRM_MODAL,
			title: "Confirm the change",
			body: "MyTassel double-checks before changing your account type. Read the message in this window, then we'll save the change.",
			placement: "bottom",
			completeWhenTargetGone: "account-type-select",
			allowBack: false,
		},
		{
			id: "account-type-confirm-save",
			target: SPOTLIGHT_TARGETS.PROFILE_ACCOUNT_TYPE_CONFIRM,
			silent: true,
			interactive: true,
			instruction: "Click Save Changes",
			waitFor: [
				{ event: SPOTLIGHT_EVENTS.PROFILE_ACCOUNT_TYPE_CHANGED },
				{ event: SPOTLIGHT_EVENTS.PROFILE_ACCOUNT_TYPE_CHANGE_CANCELLED, goto: "account-type-select" },
			],
		},
		{
			id: "account-type-success-modal",
			target: SPOTLIGHT_TARGETS.PROFILE_ACCOUNT_TYPE_SUCCESS_MODAL,
			title: "You're a Graduate now",
			body: "Your account has been updated. Refreshing the page makes sure everything on MyTassel reflects your new account type.",
			placement: "bottom",
			completeWhenTargetGone: COMPLETE_CHAPTER,
			allowBack: false,
		},
		{
			id: "account-type-refresh",
			target: SPOTLIGHT_TARGETS.PROFILE_REFRESH_NOW,
			silent: true,
			interactive: true,
			instruction: "Click Refresh Now",
			waitFor: { event: SPOTLIGHT_EVENTS.PROFILE_REFRESH_REQUESTED },
			completeWhenTargetGone: true,
			skipTo: () => COMPLETE_CHAPTER,
		},
		{
			id: "save",
			target: SPOTLIGHT_TARGETS.PROFILE_SAVE,
			title: "Save your changes",
			body: "Whenever you update something on this page, press Save to keep it.",
		},
	],
};

export default basicProfileChapter;
